import React from 'react';
import { validateCoordinates, createLocationPoint } from '../utils/setupOperations';
import '../../../styles/modes/setupMode.css';

/**
 * Manual Input Form component for adding locations manually
 */
const ManualInputForm = ({ 
  newLocation, 
  setNewLocation, 
  error, 
  setError, 
  locations, 
  setLocations 
}) => {
  // Handle form input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewLocation({
      ...newLocation,
      [name]: value
    });
  };
  
  // Manually add location point
  const handleAddManualLocation = (e) => {
    e.preventDefault();
    
    const { latitude, longitude } = newLocation;
    
    // Validate input
    if (!latitude || !longitude) {
      setError("Please complete the location information");
      return;
    }
    
    // Convert to numbers
    const lat = parseFloat(latitude);
    const lng = parseFloat(longitude);
    
    // Validate coordinates
    if (!validateCoordinates(lat, lng)) {
      setError("Please enter valid coordinates");
      return;
    }
    
    // Create new location point
    const newPoint = createLocationPoint(lat, lng, locations.length + 1);
    
    // Update location list
    setLocations([...locations, newPoint]);
    setError('');
    
    // Reset form
    setNewLocation({ latitude: '', longitude: '' });
  };
  
  return (
    <div className="manual-input-section">
      <h4>Manual Location Input</h4>
      {error && <div className="error-message">{error}</div>}
      <form className="manual-form" onSubmit={handleAddManualLocation}>
        <input 
          type="text" 
          name="latitude"
          value={newLocation.latitude}
          onChange={handleInputChange}
          placeholder="Latitude (-90 ~ 90)" 
          className="manual-input" 
        />
        <input 
          type="text" 
          name="longitude"
          value={newLocation.longitude}
          onChange={handleInputChange}
          placeholder="Longitude (-180 ~ 180)" 
          className="manual-input" 
        />
        <button type="submit" className="manual-add-btn">Add</button>
      </form>
    </div>
  );
};

export default ManualInputForm; 